<template>
<div>
  <div class="wrapper">
      <div class="content">
              <div>愿望：{{wish.name}}</div>
              <div>许愿人数：{{wish.count}}</div>
          </div>
      <div class="button-wrapper">
          <img src="../../assets/modal/confirm7.png" alt="" class="button"  @click="$emit('wishShareTip-share')">
      </div>
      
  </div>
</div>
</template>

<script>
import * as api from '@/api/index'
export default {
    name: 'wishSocks',
    props: ["wishData", "socksIndex"],
    data() {
        return {
            wish: {}
        }
    },
    watch: {
        socksIndex(newV, oldV) {
            this.socks()
        }
    },
    mounted() {
        this.socks()
    },
    methods: {
       async socks() {
           console.log(this.socksIndex, this.wishData)
            const res = await api.wishSocks({
                activity_id: this.wishData.activity_id,
                desire_id: this.wishData.desires[this.socksIndex].id
            })
                .catch(err => {

                    })
            this.wish = res || {}
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 91.76vw;
    margin: 0 auto;
    margin-top: 14vw;
    min-height: 63.33vw;
    background-image: url("../../assets/modal/share.png");
    background-size: 100% 100%;
    overflow: hidden;
    .content {
        margin: 20vw auto 0;
        width: 70%;
        text-align: center;
        min-height: 20vw;
        font-size: 24px;
        font-weight: bold;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button {
        width: 33.15vw;
        margin: 2vw 2vw;
        display: block;
        flex-shrink: 0;
    }
}

</style>